import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import Select from "react-select";

export default class EssenceReferencePositionEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      pending: false,
      category: [],
      structure: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = async () => {
    this.setState({ pending: true });
    const editData = this.props.data;
    let category = [];
    let categoryQuery = await this.context.api.qa("/category/list", {
      search: [
        {
          field: "typecode",
          compare: "EQL",
          value: "position.category",
        },
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(categoryQuery)) {
      categoryQuery.forEach((item) => {
        category.push({
          value: item.id,
          label: item.label,
        });
      });
    }

    let structure = [];
    /*let structureQuery = await this.context.api.qa("/structure/list", {
      search: [
        {
          field: "typecode",
          compare: "EQL",
          value: "soc.structure",
        },
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(structureQuery)) {
      structureQuery.forEach((item) => {
        structure.push({
          value: item.id,
          label: item.label,
        });
      });
    }*/

    this.setState(
      {
        category,
        structure,
        editData,
        pending: false,
      },
      () => this.triggerChange()
    );
  };

  getReferenceValue = (value, reference) => {
    if (Array.isArray(reference)) {
      return reference.find((item) => item.value === value) || null;
    }
    return {};
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  triggerChange = () => {
    if (this.props.onChange) {
      this.props.onChange({
        category: this.state.editData.category || this.context.api.nullUuid,
      });
    }
  };

  render() {
    const editData = this.state.editData || {};

    return (
      <>
        <Blocker on={this.state.pending}>
          <div className="form-group">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Категория:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.category,
                      this.state.category
                    )}
                    onChange={(result) =>
                      this.onChange("category", result.value)
                    }
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.category}
                    placeholder="Выберите категорию..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>

              {/*this.state.structure.length > 0 ? (
                <div className="col-lg-12">
                  <label>В структуре организации:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.structure,
                      this.state.structure
                    )}
                    onChange={(result) =>
                      this.onChange("structure", result.value)
                    }
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.structure}
                    placeholder="Выберите категорию..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              ) : (
                <div className="col-lg-12">
                  <div className="text-dark-50 text-center">
                    <i className="fa fa-exclamation-triangle mr-3"></i>
                    Не удалось определить структуру организации. Указание
                    должности в разрезе структуры организации будет недоступно
                  </div>
                </div>
              )*/}
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
